import { forwardRef, type HTMLAttributes } from 'react';

export const VirtuosoTouchPanScroller = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={`hiddenScrollBar overscroll-none overflow-x-hidden touch-pan-y ${className ?? ''}`.trim()}
      {...props}
    />
  )
);
VirtuosoTouchPanScroller.displayName = 'VirtuosoTouchPanScroller';
